import { Dialog } from 'radix-ui'
import type { TaskFile } from '../../types'

interface Props {
  file: TaskFile
  onConfirm: () => void
  onCancel: () => void
}

/** Radix Dialog potwierdzający usunięcie pliku z taska. */
export function FileDeleteDialog({ file, onConfirm, onCancel }: Props) {
  return (
    <Dialog.Root open onOpenChange={(open) => { if (!open) onCancel() }}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-50 bg-black/40" />
        <Dialog.Content className="fixed left-1/2 top-1/2 z-50 -translate-x-1/2 -translate-y-1/2 rounded bg-white p-6 shadow-lg">
          <Dialog.Title className="text-base font-semibold">Usunąć plik?</Dialog.Title>
          <Dialog.Description className="mt-2 text-sm text-slate-600">
            Czy na pewno chcesz usunąć plik <strong>{file.filename}</strong>? Operacja jest
            nieodwracalna.
          </Dialog.Description>
          <div className="mt-4 flex justify-end gap-2">
            <button
              type="button"
              onClick={onCancel}
              className="rounded border border-slate-300 px-3 py-1.5 text-sm hover:bg-slate-100"
            >
              Anuluj
            </button>
            <button
              type="button"
              onClick={onConfirm}
              className="rounded bg-red-600 px-3 py-1.5 text-sm text-white hover:bg-red-700"
            >
              Usuń
            </button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
